import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4e0fe59a5142/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/sections/DeviceShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/sections/EnhancedTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de4e0fe59a5142/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de4e0fe59a5142/components/ui/LazyVideo.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/app/[locale]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de4e0fe59a5142/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
